import Highcharts from 'highcharts';
import addTreemapModule from 'highcharts/modules/treemap';
import { Component, useState } from "react"


addTreemapModule(Highcharts);


class CTreeMapHighcharts extends Component {
  id = 'genericchart'
  state = {
    init: false,
    container: false,
    
  }
  constructor (props) {
    super(props)
    this.id = this.props.id || this.id
    // console.log('construtot modal')
  }
  componentDidUpdate (props, state) {
    
    if (this.state.container !== false && this.state.init) {
      // console.log(this.props.options)
      (function(H) {
        let pick = H.pick,
          defined = H.defined,
          fireEvent = H.fireEvent
        H.wrap(H.Legend.prototype.getAllItems = function(p) {
          var allItemsFirst = [],
            allItems = [];
          this.chart.series.forEach(function(series) {
            var seriesOptions = series && series.options;
            // Handle showInLegend. If the series is linked to another series,
            // defaults to false.
            if (series && pick(seriesOptions.showInLegend, !defined(seriesOptions.linkedTo) ? void 0 : false, true)) {
              // Use points or series for the legend item depending on
              // legendType
              allItemsFirst = allItems.concat(series.legendItems ||
                (seriesOptions.legendType === 'point' ?
                  series.data :
                  series));
            }
          });
      
          allItemsFirst.forEach(el => {
            if (el.isVisibleInLegend) {
              allItems.push(el)
            }
          })
      
          fireEvent(this, 'afterGetAllItems', {
            allItems: allItems
          });
          return allItems;
        });
      }(Highcharts));
      Highcharts.setOptions({
        lang: {
            thousandsSep: '.',
            decimalPoint: ','
        }
      });
      let chart = Highcharts.chart(this.id, this.props.options);
      this.props.callbackchart(chart)
    }
  }

  componentWillUnmount  () {
    
  }
  componentDidMount (props, state) {
    // console.log('gggggggggg', this.props, this.state)
    // console.log(this.props.footer)
    
    setTimeout(() => {
      this.setState({
        init: true,
        container: <div id={ this.id }></div>
      })
      // console.log(this.state.container)
    }, 500)

    // console.log(this.state.container)
    
  }
  render () {
    return (
      this.state.init ? this.state.container : (this.props.loader ? this.props.loader : <h1>Cargando</h1>)
    )
  }
      // setActive(props.active !== activec? props.active: false)
    // const page_data = useSelector((state) => {
    //     // console.log(state)
    //     return state.HeroBarReducer
    // });

        
    
}

export default CTreeMapHighcharts